import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, AppContextType } from '@contexts/AppContext';
import { DatabaseProps } from '@interfaces/projects';

import Layout from './Layout';

interface AIDataCenterDatabaseProps<TData, TValue>
  extends AppContextType,
    DatabaseProps<TData, TValue> {}

const queryClient = new QueryClient();

const AIDataCenterDatabase = <TData, TValue>({
  env,
  initialCurrentUser,
  isWebview,
  ...props
}: AIDataCenterDatabaseProps<TData, TValue>): JSX.Element => {
  return (
    <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
      <QueryClientProvider client={queryClient}>
        <Layout {...props} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default AIDataCenterDatabase;
